import Footer from "./Footer";
import Navbar from "./Navbar";

export const Maintenance = () => (
<>
<Navbar />


<section className="bg-green-700 text-white px-6 py-28 text-center">
<h1 className="text-5xl font-extrabold">Turf Maintenance Services</h1>
<p className="text-xl max-w-3xl mx-auto mt-4">
Increase the lifespan and performance of your synthetic turf with expert brushing,
infill top-up, drainage cleaning, deep grooming, and full surface restoration.
</p>
</section>


<section className="container mx-auto px-6 py-20 space-y-14">
<article>
<h2 className="text-3xl font-bold">Routine Brushing & Grooming</h2>
<p className="mt-3 text-lg">
Regular brushing prevents matting, restores turf fibers, and improves ball movement.
Our industrial grooming machines help maintain optimal performance.
</p>
</article>


<article>
<h2 className="text-3xl font-bold">Infill Top-Up & Redistribution</h2>
<p className="mt-3 text-lg">
Infill gradually shifts during play. We inspect levels, add silica sand or SBR granules,
and redistribute evenly to maintain shock absorption.
</p>
</article>


<article>
<h2 className="text-3xl font-bold">Deep Cleaning & Dust Removal</h2>
<p className="mt-3 text-lg">
Our deep-cleaning process removes accumulated dust, debris, and compacted dirt,
restoring turf hygiene and improving drainage.
</p>
</article>


<article>
<h2 className="text-3xl font-bold">Drainage System Restoration</h2>
<p className="mt-3 text-lg">
Poor drainage leads to waterlogging and rapid turf wear. We flush drainage channels,
correct slopes, and restore proper water flow.
</p>
</article>


<article>
<h2 className="text-3xl font-bold">Seam & Shockpad Repairs</h2>
<p className="mt-3 text-lg">
Loose seams or worn-out shockpads can be hazardous. We re-secure joints, replace damaged
turf strips, and reinforce shockpad layers for long-term durability.
</p>
</article>
</section>



<Footer />
</>
);